<template>
  <div class="TriggerSet">
    <el-form ref="form" label-width="80px">
      <el-row>
        <el-col :span="8">
          <el-form-item label="触发器名称">
            <el-input v-model="triggerInfo.trigger_Name"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="触发类型">
            <el-select v-model="triggerInfo.type" placeholder="请选择">
              <el-option label="添加" value="1" ></el-option>
              <el-option label="修改" value="2" ></el-option>
              <el-option label="删除前" value="3" ></el-option>
              <!-- <el-option label="批量添加" value="4" ></el-option>
              <el-option label="批量修改" value="5" ></el-option>
              <el-option label="批量删除" value="6" ></el-option> -->
              <el-option label="复制" value="7" ></el-option>
              <el-option label="打印" value="8" ></el-option>
              <!-- <el-option label="导出" value="9" ></el-option> -->
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="触发器状态">
            <el-select v-model="triggerInfo.trigger_state" placeholder="请选择">
              <el-option label="启用" value="1" ></el-option>
              <el-option label="禁用" value="0" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="触发条件">
            <TjPlug :tableId="tableId" :sourceType="0" ></TjPlug>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="执行顺序">
            <el-select v-model="triggerInfo.triggerOrder" placeholder="请选择">
              <el-option v-for="index of 10" :key="index" :label="index" :value="index" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="16">
          <el-button type="primary" icon="el-icon-circle-plus" @click="addTriggerOpera(1,'添加关联对象')">添加关联对象</el-button>
          <el-button type="primary" icon="el-icon-circle-plus" @click="addTriggerOpera(2,'添加数据变更')">添加数据变更</el-button>
          <el-button type="primary" icon="el-icon-circle-plus" @click="addTriggerOpera(3,'添加数据删除')">添加数据删除</el-button>
        </el-col>
      </el-row>
      <!-- 触发器的数组 -->
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane v-for="(triggerOne,index) in triggerInfo.trigger_opera" :key="index" :label="triggerOne.type_name" :name="index+''">
          <el-row>
            <el-col :span="8">
              <el-form-item label="目标对象">
                <el-select v-model="triggerOne.goalTableObject" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="(query)=>loadTableObject(triggerOne,1,query)" :loading="tableObjectloading" @change="(chooseTable)=>tableObjectChange(triggerOne,1,chooseTable)" value-key="tableId" >
                  <el-option
                    v-for="goalTableOne in triggerOne.goalObjectArr"
                    :key="goalTableOne.tableId"
                    :label="goalTableOne.tableCnName"
                    :value="goalTableOne" >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="源对象">
                <el-select v-model="triggerOne.sourceTableObject" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="(query)=>loadTableObject(triggerOne,2,query)" :loading="tableObjectloading" @change="(chooseTable)=>tableObjectChange(triggerOne,2,chooseTable)" value-key="tableId" >
                  <el-option
                    v-for="sourceTableOne in triggerOne.sourceObjectArr"
                    :key="sourceTableOne.tableId"
                    :label="sourceTableOne.tableCnName"
                    :value="sourceTableOne" >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="triggerOne.opera_type == 1">
              <el-form-item label="是否递归">
                <el-select v-model="triggerInfo.ifDg" placeholder="请选择">
                  <el-option label="否" value="0" ></el-option>
                  <el-option label="是" value="1" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="8">
              <el-form-item label="触发条件">
                
              </el-form-item>
            </el-col> -->
          </el-row>
          <!-- 字段信息 -->
          <el-row >
            <el-col :span="8" v-if="triggerOne.opera_type == 1">
              属性名称
            </el-col>
            <el-col :span="16" v-if="triggerOne.opera_type == 1">
              值设置
            </el-col>
          </el-row>
          <el-row v-for="(goalFieldOne,index) in triggerOne.goalFieldArr" :key="index">
            <el-col :span="8" >
              {{goalFieldOne.fieldCnName}}
            </el-col>
            <el-col :span="16" >
              <div style="display: flex;">
                <el-select  v-model="goalFieldOne.fieldValueType" placeholder="请选择" @change="(fieldValueType)=>fieldValueTypeChange(triggerOne,goalFieldOne,fieldValueType)" style="width:100px;">
                  <el-option label="触发表" value="1" ></el-option>
                  <el-option label="源表" value="2" ></el-option>
                  <el-option label="数据字典" value="3" ></el-option>
                </el-select>
                <ValuePlug v-if="goalFieldOne.fieldValueType == 1 || goalFieldOne.fieldValueType == 2" :tableId="goalFieldOne.connectObjId" :sourceType="0"></ValuePlug>
                <el-select v-else-if="goalFieldOne.fieldValueType == 3" v-model="goalFieldOne.fieldChooseDicId" placeholder="请选择">
                  <el-option v-for="(dicItem,dicIndex) in goalFieldOne.dicList" :key="dicIndex" :label="dicItem.DIC_NAME" :value="dicItem.DIC_ID"></el-option>
                </el-select>
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <!-- <ValuePlug :tableId="tableId" :sourceType="0"></ValuePlug> -->
    </el-form>
  </div>
</template>

<script>
import pageUtils from '@/js/page/pageUtil.js';
import utils from '@/js/utils/util.js';
import ValuePlug from '@/components/page/pageUtil/ValuePlug.vue';
import TjPlug from '@/components/page/pageUtil/TjPlug.vue';
export default {
  name: 'TriggerSet',
  props: {
    
  },
  data() {
    return {
      tableId:0,
      triggerId:0,
      triggerInfo:{
        trigger_opera:[]
      },
      //触发器选项卡的 选中状态
      activeName:"0",
      //对象选择层当前的数据
      tableObjectArr:[],
      //对象选择层的加载状态
      tableObjectloading:false
    };
  },
  created() {
    var paramsJson = this.$route.query;
    this.tableId = paramsJson.tableId;
  },
  mounted() {
    
  },
  watch:{
  },
  computed:{
  },
  components: {
    ValuePlug,
    TjPlug
  },
  methods: {
    /**
     * 添加一个触发器执行操作
     */
    addTriggerOpera:function(type, type_name){
      var that = this;
      var triggerInfo = that.triggerInfo;
      var triggerOne = {
        type_name:type_name,
        opera_type:type,
        goalTableObject:null,
        sourceTableObject:null,
        goalFieldArr:[]
      }
      triggerInfo.trigger_opera.push(triggerOne);
    },
    /**
     * 加载对象弹出层信息 
     */
    loadTableObject:function(triggerOne,type,query){
      console.log("query================",query);
      var that = this;
      var url = "dialog_getAllTableInfo.do";
      var toHtData={};
      that.tableObjectloading = true;
      if (query !== '') {
        toHtData.tableCnNameSearch = query;
        toHtData.start = 0;
        toHtData.limit = "10000_flow";
        toHtData.ifAjaxCount = false;
      } else {
        toHtData.start = 0;
        toHtData.limit = "15_flow";
        toHtData.ifAjaxCount = false;
      }
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
            if(type == 1) {
              triggerOne.goalObjectArr = res.data.rows;
            } else if(type == 2) {
              triggerOne.sourceObjectArr = res.data.rows;
            }
          }
          that.tableObjectloading = false;
        }
      })
    },
    tableObjectChange:function(triggerOne, type, chooseTable){
      if(type == 1) {
        triggerOne.objId = triggerOne.goalTableObject.tableId;
        triggerOne.objName = triggerOne.goalTableObject.tableName;
        //加载字段信息 
        this.loadFieldObject(triggerOne);
      }
      if(type == 2) {
        triggerOne.sourceObjId = triggerOne.sourceTableObject.tableId;
        triggerOne.sourceObjName = triggerOne.sourceTableObject.tableName;
      }
      console.log("triggerOne=============",triggerOne,chooseTable);
    },
    /**
     * 加载字段信息 根据目标对象
     */
    loadFieldObject:function(triggerOne){
      var that = this;
      var url = "plug_TriggerGetFieldInfoByTableId.do";
      var toHtData = {
        tableId:triggerOne.objId
      };
      toHtData.start = 0;
      toHtData.limit = "999_flow";
      toHtData.ifAjaxCount = true;
      utils.request(that,{
        url: url, 
        data: toHtData,
        success: function (res) {
          console.log(res.data);
          if(res.data) {
            var goalFieldArr = [];
            res.data.rows.forEach(element=>{
              if(typeof(element.dicJson) == "string") {
                element.dicList = JSON.parse(element.dicJson);
              }
              element.fieldValueType = "1";
              element.connectObjId = that.tableId;
              goalFieldArr.push(element);
            })
            triggerOne.goalFieldArr = goalFieldArr;
          }
        }
      })
    },
    /**
     * 添加触发器 字段的对象类型的切换事件
     */
    fieldValueTypeChange:function(triggerOne,goalFieldOne,fieldValueType){
      if(fieldValueType == 1) {
        goalFieldOne.connectObjId = this.tableId;
      } else if(fieldValueType == 2) {
        goalFieldOne.connectObjId = triggerOne.sourceObjId;
      } else {
        goalFieldOne.connectObjId = "";
      }
    }
  }
}
        
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
